/* stylelint-disable selector-no-vendor-prefix */

/**
    @prop --uic-input-field-height: The height of the input
    @prop --uic-input-field-min-width: The minimum width of the input
*/

uic-input-field {
  box-sizing: border-box;
  display: inline-block;
  min-width: var(--uic-input-field-min-width);
  padding: 8px;
  position: relative;
}

.uic-input-field[variant-value],
.uic-input-field--unit {
  .uic-input-field__input {
    text-align: right;
  }

  .uic-input-field__flag {
    left: 4px;
    right: unset;
  }

  &.uic-input-field--invalid,
  &.uic-input-field--flag {
    .uic-input-field__input {
      padding-left: 48px;
      padding-right: 8px;
    }
  }
}

.uic-input-field--focused {
  .uic-input-field__input-wrapper {
    color: var(--uic-color-black);
    outline: 2px solid var(--uic-color-blue2);
    outline-offset: -2px;
  }
}

.uic-input-field--flag,
.uic-input-field--invalid {
  .uic-input-field__flag {
    display: block;
  }
}

.uic-input-field--invalid {
  .uic-input-field__input {
    padding-right: 48px;
  }

  .uic-input-field__helper-text {
    color: var(--uic-color-red1);
  }
}

.uic-input-field.uic-input-field--has-label {
  padding: 2px 8px 8px;

  .uic-input-field__label {
    display: block;
    padding-bottom: 4px;
  }
}

.uic-input-field.uic-input-field--has-helper-text {
  padding-bottom: 1px;

  .uic-input-field__helper-text {
    margin-top: 3px;
  }
}

.uic-input-field[disabled] .uic-input-field__input-wrapper {
  border: 1px solid var(--uic-color-grey2a25);
}

.uic-input-field__input-wrapper {
  background: var(--uic-color-white);
  border: 1px solid var(--uic-color-grey2);
  box-sizing: border-box;
  display: flex;
  position: relative;

  &:hover {
    border-color: var(--uic-color-blue2);
    color: var(--uic-color-blue3);
  }

  &:active {
    background: var(--uic-color-blue2a10);
    border: 1px solid var(--uic-color-blue2);
    color: var(--uic-color-blue3);
  }
}

.uic-input-field__label {
  color: var(--uic-color-black);
  font-size: var(--uic-font-size-normal);
  line-height: var(--uic-line-height-normal);
  overflow: hidden;
  text-overflow: ellipsis;
}

.uic-input-field__input {
  @include font(medium, semibold);
  background: transparent;
  border: 0;
  border-radius: 0;
  box-sizing: border-box;
  caret-color: var(--uic-color-blue2);
  color: inherit;
  flex: 1 1 auto;
  height: 100%;
  min-width: 0;
  outline: none;
  padding: 8px;
  text-overflow: ellipsis;

  &::placeholder {
    color: var(--uic-color-grey3a50);
    font-weight: normal;
  }

  &::selection {
    background-color: var(--uic-color-blue2);
    color: var(--uic-color-white);
    line-height: 24px;
  }

  &::-moz-selection {
    background-color: var(--uic-color-blue2);
    color: var(--uic-color-white);
  }

  &:disabled::selection {
    background-color: transparent;
    color: inherit;
  }
}

.uic-input-field__flag {
  display: none;
  height: var(--uic-icon-width);
  position: absolute;
  right: 4px;
  top: 50%;
  transform: translateY(-50%);
  width: var(--uic-icon-width);

  svg {
    height: 100%;
    width: 100%;
  }
}

.uic-input-field__clear-button {
  --uic-icon-width: var(--uic-icon-dimensions-default);
  --uic-icon-height: var(--uic-icon-dimensions-default);
  background: none;
  border: 0;
  color: var(--uic-icon-button-color);
  cursor: pointer;
  height: var(--uic-icon-dimensions-default);
  margin: 0;
  outline: 0;
  padding: 0;
  position: relative;
  right: 8px;
  top: 50%;
  transform: translateY(-50%);
  width: var(--uic-icon-dimensions-default);
}

.uic-input-field__unit {
  @include font(normal, semibold);
  align-items: flex-end;
  box-sizing: border-box;
  color: var(--uic-color-black);
  display: flex;
  justify-content: center;
  padding: 8px;
  position: relative;

  &::before {
    background: var(--uic-color-grey2);
    bottom: 7px;
    content: '';
    left: 0;
    position: absolute;
    top: 7px;
    width: 1px;
  }
}

.uic-input-field__helper-text {
  color: var(--uic-color-black);
  font-size: 0.8rem;
  line-height: 1.3rem;
  overflow: hidden;
  text-overflow: ellipsis;

  &-inner {
    @include truncate();
  }
}

uic-input-field[disabled] {
  pointer-events: none;

  .uic-input-field {
    &__input {
      background: var(--uic-color-white);
      border-color: var(--uic-color-grey2a25);
      color: var(--uic-color-grey3a50);
      font-weight: var(--uic-font-weight-normal);
    }

    &__unit {
      color: var(--uic-color-grey3a50);
    }
  }
}

@media #{$breakpoint_tablet} {
  .uic-input-field__input-wrapper {
    height: 40px;
  }
}

@media #{$breakpoint_desktop} {
  .uic-input-field__input-wrapper {
    height: 48px;
  }
}

@media #{$breakpoint_tablet_small} {
  .uic-input-field__input-wrapper {
    height: 30px;
  }
}
